export const getFirstLetterOfString = (string) => {
    return string.charAt(0).toUpperCase();
}